import { createSlice } from "@reduxjs/toolkit";
import {
  MODULEAIRLINE,
  MODULEBRIFING,
  MODULEFLEET,
  MODULELIBRARY,
  MODULEOFP,
  MODULEPERFORMANCE,
  MODULEREPORT,
  MODULEUSER,
  MODULEWB,
  MODULEFLIGHT,
  MODULELMS,
} from "./module.mode";
import { resetStore } from "store/actions";

const initialExpirationDate = new Date().toISOString();

const normalizeModules = (modules) => {
  if (!modules || typeof modules !== "object" || Array.isArray(modules)) {
    return modules;
  }

  return Object.entries(modules).reduce((acc, [key, module]) => {
    if (!module || typeof module !== "object") {
      acc[key] = module;
      return acc;
    }

    acc[key] = {
      ...module,
      expiration_date:
        module.expiration_date instanceof Date
          ? module.expiration_date.toISOString()
          : module.expiration_date,
    };
    return acc;
  }, {});
};

const initialState = {
  status: "init",
  // modules: {
  //   lib: {
  //     date: new Date(2019, 1, 1),
  //     settings: {},
  //   },
  // },
  modules: {
    [MODULEFLIGHT]: {
      exist: false,
      enabled: false,
      expiration_date: initialExpirationDate,
      module: "enr:flight:module",
    },
    [MODULELIBRARY]: {
      exist: false,
      enabled: false,
      expiration_date: initialExpirationDate,
      module: "enr:library:module",
    },

    [MODULEUSER]: {
      exist: false,
      enabled: false,
      expiration_date: initialExpirationDate,
      module: "enr:user:module",
    },

    [MODULEFLEET]: {
      exist: false,
      settings: {},
      enabled: false,
      expiration_date: initialExpirationDate,
      module: "enr:fleet:module",
    },

    [MODULEOFP]: {
      exist: false,
      enabled: false,
      expiration_date: initialExpirationDate,
      module: "enr:ofp:module",
    },

    [MODULEBRIFING]: {
      exist: false,
      enabled: false,
      expiration_date: initialExpirationDate,
      module: "enr:briefing:module",
    },

    [MODULEWB]: {
      exist: false,
      enabled: false,
      expiration_date: initialExpirationDate,
      module: "enr:w&b:module",
    },

    [MODULEPERFORMANCE]: {
      exist: "",
      enabled: false,
      expiration_date: initialExpirationDate,
      module: "enr:performance:module",
    },

    [MODULEREPORT]: {
      exist: "",
      enabled: false,
      expiration_date: initialExpirationDate,
      module: "enr:report:module",
    },

    [MODULEAIRLINE]: {
      exist: "",
      enabled: false,
      expiration_date: initialExpirationDate,
      module: "enr:airline:module",
    },

    [MODULELMS]: {
      exist: false,
      enabled: false,
      expiration_date: initialExpirationDate,
      module: "enr:lms:module",
    },
  },
  airline: "",
  refresh: null,
};

const modulesSlice = createSlice({
  name: "modules",
  initialState,
  extraReducers: (builder) => builder.addCase(resetStore, () => initialState),
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    setModules: (state, action) => {
      state.modules = normalizeModules(action.payload);
    },
    setAirlineInModules: (state, action) => {
      state.airline = action.payload;
      console.log("action", action);
    },
  },
});

export const { actions } = modulesSlice;
export const { setLoading, setModules, setAirlineInModules } = actions;

// selectors
export const selModsOBJ = (state) => state.modules.modules;
export const selModules = (state) => state.modules.modules;
export const selAirlineInModules = (state) => state.airline.modules;

const reducer = {
  modules: modulesSlice.reducer,
};

export default reducer;
